import {ChangeDetectionStrategy, Component, Inject, inject} from "@angular/core";
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from "@angular/material/snack-bar";

@Component({
  templateUrl: './snack-bar-template.component.html',
  styleUrls: ['./snack-bar-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackBarTemplateComponent {

  readonly snackBarRef = inject(MatSnackBarRef);
  readonly content: string;
  readonly type: 'create' | 'update' | 'delete' | 'admin-server-error' | 'user-server-error' | 'error';

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
    this.content = data.label;
    this.type = data.type;
  }

  public refreshPage() {
    window.location.reload();
  }

  public navigateToContact() {
    //console.log("Need contact us")
  }
}
